import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import 'babel-polyfill'
import { Navigation } from '../components/Navigation';

import './index.css'
import '../assets/scss/init.scss';
const TemplateWrapper = ({ children, location }) => {
    return (
        <div>
            <Helmet
                title="Adrian-Gabriel Manduc | Fullstack Developer"
                meta={[
                    { name: 'description', content: 'Fullstack developer based in Bucharest. Expertise in  mobile app development, web development and UI/UX design' },
                    { name: 'keywords', content: 'adrian, manduc, adrian-gabriel, adrian manduc, adrian-gabriel manduc, fullstack, developer, frontend, ux, ui, bucharest, romania, mobile, app, UI/UX, design, programming' },
                ]}
            />
            <Navigation className={location.pathname} />
            {children()}
        </div>
    )
};

TemplateWrapper.propTypes = {
    children: PropTypes.func,
}

export default TemplateWrapper


// WEBPACK FOOTER //
// ./src/layouts/index.js